import { render } from "./TransactionView.vue?vue&type=template&id=f0976f8a&scoped=true"
import script from "./TransactionView.vue?vue&type=script&lang=js"
export * from "./TransactionView.vue?vue&type=script&lang=js"

import "./TransactionView.vue?vue&type=style&index=0&id=f0976f8a&lang=scss"
import "./TransactionView.vue?vue&type=style&index=1&id=f0976f8a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0976f8a"]])

export default __exports__